import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import { fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";
import { BaseUrl } from "../..";
const CourseCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    status: "1",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchAllDetails = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await fetchFormData(`course-details`, formData, "POST");

      if (result?.success && result?.data) {
        const d = result.data;

        setFormData({
          id: d.id,
          title: d.title || "",
          status: d.status?.toString() || "1",
        });
      } else {
        topTost({ title: "Course not found", icon: "warning" });
      }
    } catch (error) {
      console.log("Fetch error:", error);
      topTost({ title: "Server error", icon: "error" });
    }
  };

  useEffect(() => {
    if (id) {
      fetchAllDetails(id);
    }
  }, [id]);

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  const form = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    form.append(key, value ?? "");
  });

  try {
    // Manually fetch the data instead of using fetchFormData (only here)
    const token = localStorage.getItem("access_token");
    const response = await fetch(id ? `${BaseUrl}update-course/${id}` : `${BaseUrl}insert-course`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form,
    });
    const data = await response.json();
    const result = data.result;
if(!result)return
    // Validation error check
    if (result?.errors) {
      const firstField = Object.keys(result.errors)[0];
      const errorMsg = result.errors[firstField][0];
      topTost({ title: errorMsg, icon: "error" });
      setIsSubmitting(false);
      return;
    }

    // Success check
    if (
      result?.success === "true" ||
      result?.success === true ||
      result?.code === 200 ||
      result?.code === "200"
    ) {
      topTost({
        title:
          result?.message ||
          (id ? "Updated successfully!" : "Saved successfully!"),
        icon: "success",
      })
      setTimeout(() => {
          navigate("/master/course-list");
      }, 600);

    
      setIsSubmitting(false);
      return;
    }

    // Other errors
    topTost({
      title: result?.message || "Error submitting form",
      icon: "error",
    });
  } catch (error) {
    topTost({ title: "Error submitting form", icon: "error" });
  } finally {
    setIsSubmitting(false);
  }
};



  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                {id ? "Edit Course:" : "Add Course:"}
              </h5>
            </div>
            <form onSubmit={handleSubmit} className="p-3 ">
              <Input
                label="Course Title"
                name="title"
                placeholder="Enter Course Title"
                value={formData.title}
                onChange={handleChange}
                icon="feather-hash"
                
                required
              />

              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CourseCreate;
